import Dot from '../Dot';

const BlueDot = ({ customColor }: { customColor?: string }) => {
  return <Dot color={customColor || 'persistentSemanticBlue'} />;
};

export default BlueDot;
